module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/payment/payment-on-invoice-sk-ca3d36e7c772f0a6b8d2a3cf5f619d1d.svg";